"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFile = parseFile;
exports.inputsToFile = inputsToFile;
const property_1 = require("@genesys/property");
const AirInputsDefinition = __importStar(require("./property-definitions/common/airinputs-definition"));
const Inputs = __importStar(require("./inputs"));
const Types = __importStar(require("./types"));
const PropertyValueSetHelper = __importStar(require("@genesys/shared/lib/property-value-set-helper"));
// The coil type is no longer a property, so it cannot ride along in the property table. It gets
// the first column of its own instead, ahead of the groups, and it is what tells Import which
// properties the rest of the columns are.
const coilTypeColumn = "coiltype";
function parseFile(data) {
    const coilType = readCoilType(data);
    // Everything after the coil type is the property table the groups describe.
    const table = data.map(row => row.slice(1));
    const fieldGroups = table[0]
        .map((name, groupBegin) => ({ name, groupBegin }))
        .filter(({ name }) => !!name)
        .map(({ name, groupBegin }, i, array) => {
        const nextGroup = array[i + 1];
        const groupEnd = nextGroup && nextGroup.groupBegin;
        return { name, groupBegin, groupEnd };
    });
    const pvses = table.slice(2).map(propertyValueStrings => {
        const parsedFields = fieldGroups
            .map(({ name, groupBegin, groupEnd }) => {
            const fieldNames = table[1].slice(groupBegin, groupEnd);
            const properties = fieldNames.map((name2, fieldIndex) => ({
                name: name2,
                propertyValueString: propertyValueStrings[groupBegin + fieldIndex]
            }));
            const propertyValueSet = properties.reduce((soFar, next) => property_1.PropertyValueSet.merge(soFar, property_1.PropertyValueSet.fromProperty(next.name, property_1.PropertyValue.fromString(next.propertyValueString))), property_1.PropertyValueSet.Empty);
            return name === "airinputs"
                ? fixAirinputs(propertyValueSet)
                : propertyValueSet;
        })
            .reduce((soFar, next) => property_1.PropertyValueSet.merge(soFar, next), property_1.PropertyValueSet.Empty);
        return parsedFields;
    });
    return { coilType, pvses };
    function fixAirinputs(dirtyAirInputs) {
        return PropertyValueSetHelper.cleanifyPropertyValueSet(dirtyAirInputs, AirInputsDefinition.propertyDefinition(dirtyAirInputs));
    }
}
/**
 * A file that does not say which coil it describes cannot be imported: the property names alone
 * would have to be guessed at, and a guess would silently load the wrong definitions.
 */
function readCoilType(data) {
    const stated = ((data[2] && data[2][0]) || "").trim().toLowerCase();
    const known = Types.coilTypes.find(c => c === stated);
    if (!known) {
        throw new Error(`This file does not say which coil it describes - its first column should hold one of ` +
            `${Types.coilTypes.join(", ")}, and holds "${stated}". Download a fresh file from the ` +
            `coil type you want and fill that in.`);
    }
    return known;
}
function inputsToFile(coilType, inputs) {
    const groups = Inputs.inputGroups(coilType);
    return [
        [
            coilTypeColumn,
            ...[].concat(...groups.map(fieldGroup => [
                fieldGroup.groupName,
                ...fieldGroup.propertyNames.slice(1).map(_ => "")
            ]))
        ],
        [
            coilTypeColumn,
            ...[].concat(...groups.map(fieldGroup => [...fieldGroup.propertyNames]))
        ],
        [
            coilType,
            ...[].concat(...groups.map(fieldGroup => fieldGroup.propertyNames.map(fieldName => property_1.PropertyValue.toString(property_1.PropertyValueSet.getValue(fieldName, inputs)))))
        ]
    ];
}
//# sourceMappingURL=input-file.js.map